import React from 'react';
import {
  Body,
  Box,
  FlexRow,
  Money,
  Col,
  Card,
  Flex,
  ArrowUpTrendIcon,
} from '@edreamsodigeo/prisma-design-system';
import { useTranslation, useFlow } from '@edreamsodigeo/frontend-core';
import { Segment } from './Segment';
import { SegmentWithPrice } from './SegmentWithPrice';

const OUTBOUND = 'outbound';
const INBOUND = 'inbound';

const PrimePriceLabel = () => {
  const { t } = useTranslation();
  return <>{t('itinerarydetails.total.primeprice')}</>;
};

export const ItineraryDetails = ({
  itinerary,
  hasPill,
  primePriceLabel,
  frozenPrice,
}) => {
  const CardPadding = useFlow() === 'desktop' ? '5' : '3';
  return (
    <Card p={CardPadding}>
      <ItineraryDetailsFlightPrice itinerary={itinerary} />
      <ItineraryDetailsPrice
        frozenPrice={frozenPrice}
        hasPill={hasPill}
        primePriceLabel={primePriceLabel}
      />
    </Card>
  );
};

export const ItineraryDetailsNoPrice = ({ itinerary }) => {
  return (
    <Box backgroundColor="white" p="base" borderRadius={2}>
      <ItineraryDetailsFlight itinerary={itinerary} />
    </Box>
  );
};

const ItineraryDetailsFlight = ({ itinerary }) => {
  return (
    <>
      <Segment segment={itinerary.legs[0].segments[0]} type={OUTBOUND} />
      {itinerary.tripType === 'ROUND_TRIP' && (
        <Box
          pt="base"
          mt="base"
          sx={{
            borderTopWidth: '1px',
            borderTopStyle: 'solid',
            borderTopColor: 'neutral.40',
          }}
        >
          <Segment segment={itinerary.legs[1].segments[0]} type={INBOUND} />
        </Box>
      )}
    </>
  );
};

const ItineraryDetailsFlightPrice = ({ itinerary }) => {
  return (
    <>
      <SegmentWithPrice
        segment={itinerary.legs[0].segments[0]}
        type={OUTBOUND}
      />
      {itinerary.tripType === 'ROUND_TRIP' && (
        <Box mt="big">
          <SegmentWithPrice
            segment={itinerary.legs[1].segments[0]}
            type={INBOUND}
          />
        </Box>
      )}
    </>
  );
};

const WarningBgPill = () => {
  const { t } = useTranslation();
  return (
    <Box
      px="small"
      py="2x_small"
      mt="1x_small"
      sx={{
        background: 'linear-gradient(90deg, #D83945 14.13%, #F9700C 85.87%)',
        borderRadius: '21px',
        display: 'table',
      }}
    >
      <Flex justifyContent="flex-start" alignItems="center">
        <Box pr="2x_small">
          <ArrowUpTrendIcon size="small" color="neutral.0" />
        </Box>
        <Box>
          <Body type="small" weight="normal" color="neutral.0">
            {t('error.sessionabouttoexpire.hurry.text')}
          </Body>
        </Box>
      </Flex>
    </Box>
  );
};
const ItineraryDetailsPrice = ({ hasPill, primePriceLabel, frozenPrice }) => {
  return (
    <>
      <FlexRow justifyContent="flex-end" mt="big" alignItems="center">
        <Money size="small" currency={frozenPrice?.currency}>
          {frozenPrice?.amount}
        </Money>
      </FlexRow>
      <FlexRow justifyContent="space-between" alignItems="center">
        <Col>{hasPill === true ? <WarningBgPill /> : null}</Col>

        <Col>
          <Body textAlign="end" type="xSmall" color="neutral.70">
            {primePriceLabel || <PrimePriceLabel />}
          </Body>
        </Col>
      </FlexRow>
    </>
  );
};
